/**
 * Paletas Lorentz — derivadas do MonitorOPS (settings.lorentz-dark/light.json).
 * @see lorentz-vps-stack/docker/monitor/static/style.css
 */

export const LORENTZ_THEMES = {
  'lorentz-dark': {
    id: 'lorentz-dark',
    label: 'Lorentz Dark',
    mode: 'dark',
    colors: {
      primary: '#3F6F93',
      warning: '#D9A857',
      danger: '#D27878',
      success: '#6FD08A',
      secondary: '#4E83AC',
      borderColor: '#34546F',
      backColor: '#0B1626',
      app: '#15263D',
      textPrimary: '#E7F1F9',
      textSecondary: '#8AADCA',
      accent: '#7FB0CC'
    },
    meta: {
      themeColor: '#0B1626',
      backgroundColor: '#05080F'
    }
  },
  'lorentz-light': {
    id: 'lorentz-light',
    label: 'Lorentz Light',
    mode: 'light',
    colors: {
      primary: '#356486',
      warning: '#C8881F',
      danger: '#C0504D',
      success: '#2FA45F',
      secondary: '#5E97BC',
      borderColor: '#C2D5E5',
      backColor: '#E6EFF7',
      app: '#FFFFFF',
      textPrimary: '#0B1626',
      textSecondary: '#6E8BA3',
      accent: '#5E97BC'
    },
    meta: {
      themeColor: '#E6EFF7',
      backgroundColor: '#F4F8FC'
    }
  }
};

export const THEME_OPTIONS = [
  { value: 'auto', label: 'Automático (navegador)' },
  { value: 'lorentz-dark', label: 'Lorentz Dark' },
  { value: 'lorentz-light', label: 'Lorentz Light' }
];

export function getSystemThemePreference() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return 'lorentz-light';
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'lorentz-dark'
    : 'lorentz-light';
}

export function resolveThemeId(preference = 'auto') {
  if (preference === 'auto') {
    return getSystemThemePreference();
  }
  return LORENTZ_THEMES[preference] ? preference : getSystemThemePreference();
}

export function getTheme(preference = 'auto') {
  const id = resolveThemeId(preference);
  return LORENTZ_THEMES[id] || LORENTZ_THEMES['lorentz-light'];
}
